module.exports = __webpack_public_path__ + "static/media/loading-img.8aff620b.svg";